import Stack from "react-bootstrap/Stack";

import { formatCurrency } from "./../../../../utilities/helpers";

import { EditButton } from "../../../EditButton";
import { TrashButton } from "../../../TrashButton";

export default function PricingTier({
  pricingTier,
  handleShow,
  confirmRemoval,
}) {
  return (
    <Stack
      direction="horizontal"
      gap={4}
      as="li"
      className="justify-content-between list-item list-item-lg list-item-lg--sm list-item--light list-item--with-border"
    >
      <span className="flex gap-2 heading-sm">
        <span>{pricingTier?.name}</span>
        <span>{formatCurrency(pricingTier?.price)}</span>
      </span>
      <Stack direction="horizontal" gap={3}>
        <EditButton
          onClick={(e) => handleShow(e, pricingTier?.id)}
          size="xs"
          variant="primary"
        />
        <TrashButton
          variant="danger"
          id={pricingTier?.id}
          onClick={confirmRemoval}
          size="xs"
        />
      </Stack>
    </Stack>
  );
}
